import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import { getStrLang } from '../../Translate';
import Loading from '../../../assets/loading.gif';
import { useHistory, useLocation } from 'react-router-dom';
import { getAceiteTermos, getPixInfo } from '../../../api/fastcoinService';
import toast, { Toaster } from 'react-hot-toast';
import 'jquery-ui-dist/jquery-ui';
import PixQrSplited from '../pixQrSplited';
import BoletoSplited from '../boletoSplited';
import { IoChevronBackOutline } from 'react-icons/io5';

const PixSplited = (props) => {
    //Chamada para as variáveis e funções do Context
    const pix_avaliable = true;
    const { translate, lang, orderFromDeposit } = useLanguage();
    const [infoPix, setInfoPix] = useState(sessionStorage.getItem("pix_info") !== null ? JSON.parse(sessionStorage.getItem("pix_info")) : undefined);
    const [loadingPixInfo, setLoadingPixInfo] = useState(false);

    //Acessando informações da rota
    const history = useHistory();
    const location = useLocation();

    //Capturando parâmetros da URL /deposit
    let order_number = sessionStorage.getItem("order_no");
    const [erroPix, setErroPix] = useState(false);

    //valida se os termos da ordem foram aceitos
    useEffect(() => {
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    //console.log(res);
                    if (res !== undefined) {
                        sessionStorage.setItem("showTermos_deposit", false);
                        props.setShowTermos(false);
                        translate();
                    } else {
                        sessionStorage.setItem("showTermos_deposit", true);
                        props.setShowTermos(true);
                    }
                })
                .catch(err => {
                    if (err.error.includes("Could not find the term")) {
                        sessionStorage.setItem("showTermos_deposit", true);
                        props.setShowTermos(true);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                })
        }
        if (orderFromDeposit !== "") {
            gerarPix();
            validarTermos();
        }
    }, []);

    //Traduz o texto na tela quando mudado o idioma pelo usuário
    useEffect(() => {
        translate();
    }, [translate]);


    function gerarPix() {
        function executarGeracaoPix() {
            let orderNumber = sessionStorage.getItem("order_no");
            let valor = sessionStorage.getItem("order_amount");
            getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor)
                .then(res => {
                    if (res !== undefined) {
                        setInfoPix(res);
                        sessionStorage.setItem("pix_info", JSON.stringify(res));
                    } else {
                        setInfoPix({ error: "Please, talk with the Administrator." });
                    }
                    //props.setWaitingPayment(true);
                })
                .catch(err => {
                    getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor, true)
                        .then(res => {
                            if (res !== undefined) {
                                setInfoPix(res);
                                sessionStorage.setItem("pix_info", JSON.stringify(res));
                                props.setWaitingPayment(true);
                            } else {
                                setInfoPix({ error: "Please, talk with the Administrator." });
                            }
                            setLoadingPixInfo(false);
                            translate();
                        })
                        .catch(err => {
                            getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor, false,true)
                                .then(res => {
                                    if (res !== undefined) {
                                        setInfoPix(res);
                                        sessionStorage.setItem("pix_info", JSON.stringify(res));
                                        props.setWaitingPayment(true);
                                    } else {
                                        setInfoPix({ error: "Please, talk with the Administrator." });
                                    }
                                    setLoadingPixInfo(false);
                                    translate();
                                })
                                .catch(err => {
                                    setInfoPix({ emv: "00020101021126580014br.gov.bcb.pix0136c9834cf4-31d3-4e14-9f03-7f6876e7cd215204000053039865802BR5912Mercado Easy6009SAO PAULO622905251H5WTE0YNK59CZ0FHZYGHMAB16304F73B" });
                                    console.log(err);
                                    setLoadingPixInfo(false);
                                    translate();
                                })
                        })
                })
        }
        if (infoPix === undefined) {
            setLoadingPixInfo(true);
            executarGeracaoPix();
        }
    }

    const notify = () => {
        navigator.clipboard.writeText(infoPix.emv);
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }


    function paymentOne() {
        if (props.spt1 === "Pix") {
            return (<PixQrSplited vSpt={props.vSpt1} />);
        } else {
            return (<BoletoSplited vSpt={props.vSpt1} />);
        }
    };

    function paymentTwo() {
        if (props.spt2 === "Pix") {
            return (<PixQrSplited vSpt={props.vSpt2} />);
        } else {
            sessionStorage.removeItem("infoBillet");
            sessionStorage.removeItem("billet_redirect");
            return (<BoletoSplited vSpt={props.vSpt2} setShowTermos={props.setShowTermos} />);
        }
    };

    return (
        <div className="grup-splited-opt">
            <div className="column-pix-sides">
                <button className="btn-split-pix" onClick={() => props.setTelaPix("default")}><IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar")}</button>
            </div>
            {!erroPix ?
                infoPix !== undefined && infoPix.emv !== undefined ?
                    <div className="box-area-splited">
                        <div className="opt-splited">
                            {paymentOne()}
                        </div>

                        <div className="opt-splited">
                            {paymentTwo()}
                        </div>
                    </div>
                    :
                    <>
                        {loadingPixInfo ?
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                            :
                            <></>
                        }
                    </>

                :
                <div className="box-area-splited">
                    <div className="opt-splited">
                        {props.spt1 === "Pix"?getStrLang(lang.nameLang, "error_pix"):getStrLang(lang.nameLang, "error_boleto")}
                    </div>

                    <div className="opt-splited">
                    {props.spt2 === "Pix"?getStrLang(lang.nameLang, "error_pix"):getStrLang(lang.nameLang, "error_boleto")}
                    </div>
                </div>
            }
        </div>
    )
}

export default PixSplited;